import { gql } from "@apollo/client";

// Mutation to add a single holiday to a business
export const ADD_BUSINESS_HOLIDAY = gql`
  mutation addBusinessHoliday($businessId: Int!, $holidayId: Int!) {
    addBusinessHoliday(businessId: $businessId, holidayId: $holidayId) {
      id
      businessId
      holidayId 
    }
  }
`;

// Mutation to add multiple holidays to a business based on countryId
export const ADD_BUSINESS_HOLIDAYS_IN_BULK = gql`
  mutation addBusinessHolidaysInBulk($businessId: Int!, $countryId: Int!) {
    addBusinessHolidaysInBulk(businessId: $businessId, countryId: $countryId) {
      id
      businessId
      holidayId
    }
  }
`;


// Mutation to remove a specific holiday from a business
// Mutation to remove a specific holiday from a business
export const REMOVE_BUSINESS_HOLIDAY = gql`
  mutation removeBusinessHoliday($businessId: Int!, $holidayId: Int!) {
    removeBusinessHoliday(businessId: $businessId, holidayId: $holidayId) {
      success
      message
    }
  }
`;
